/* eslint-disable indent */
import DialogContent from '@mui/material/DialogContent';
import styled from 'styled-components';
import { COLORS } from 'theme';
import { StyledDialogActions } from '../DialogActions/DialogActions.styles';

export const StyledDialogContent = styled(DialogContent)`
  && {
    padding: ${({ theme }) => `0 ${theme.spacing.m4} ${theme.spacing.s2}`};

    ${({ $actionsBorder }) =>
      $actionsBorder &&
      `
      + ${StyledDialogActions} {
        border-top: 1px solid ${COLORS.black10};
      }
    `}

    ${({ $fixedActions, theme }) =>
      $fixedActions &&
      `
        margin-bottom: 90px;
        padding-bottom: ${theme.spacing.s3};
    `}
  }
`;
